import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'

const AddContact = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");

  const contacts = useSelector((state) => state);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  
  const handleSubmit = (e) => {
    e.preventDefault();

    const checkEmail = contacts.find(
      contact => contact.email === email && contact
    );

    const checkNumber = contacts.find(
      (contact) => contact.number === parseInt(number)
    );

    if(!name || !email || !number) {
      return (
        toast.warning("Please fill in all fields !")
      )
    }

    if(checkEmail) {
      return (
        toast.error("This email already exist !")
      )
    }

    if(checkNumber) {
      return (
        toast.error("This number already exist !")
      )
    }

    const data = {
      id: contacts[contacts.length -1].id + 1,
      name,
      email,
      number
    }

    dispatch({type: "ADD_CONTACT", payload:data});
    toast.success("Student added successfully !!");
    navigate("/");
  }

  return (
    <div className="container">
        <h1 className="display-3 my-5 text-center text-light">
            Add Contact
        </h1>
        <div className="row">
            <div className="col-md-6 shadow mx-auto p-5">
              <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input type="text" placeholder="Name" 
                    className="form-control" value={name} onChange={e => setName(e.target.value)} />
                  </div> 

                  <div className="form-group my-3">
                    <input type="email" placeholder="Email" 
                    className="form-control" value={email} onChange={e => setEmail(e.target.value)} />
                  </div>

                  <div className="form-group mb-3">
                    <input type="number" placeholder="Phone number" 
                    className="form-control" value={number} onChange={e => setNumber(e.target.value)} />
                  </div>

                  <div className="form-group">
                    <input
                      className="btn btn-block btn-dark w-100"
                      type="submit"
                      value="Add Contact"
                    />
                  </div>
              </form>
            </div>
        </div>
    </div>
  )
}

export default AddContact